import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NotFoundImage from '../assets/img/404.png';


const NotFound = () => {
    const { t } = useTranslation('notfound'); // Usando o namespace 'notfound'

    return (
        <div className="error-container container">
            <div>
                <img src={NotFoundImage} alt={t('title')} />
            </div>
            <p>
                {t('message')} 
                <Link to="/"> {t('homepage')}</Link>.
            </p>
        </div>
    );
};

export default NotFound;
